import env from '@beam-australia/react-env';

import { ENV_CONFIG_ATTRIBUTES } from 'src/config/env-config-attributes';
import { DeliveryStaticData } from 'src/static/delivery-static-data';

export const config = {
  ENV: env(ENV_CONFIG_ATTRIBUTES.ENV),
  AUTH_CLIENT_ID: env(ENV_CONFIG_ATTRIBUTES.AUTH_CLIENT_ID),
  AUTH_SCOPES: env(ENV_CONFIG_ATTRIBUTES.AUTH_SCOPES),
  AUTH_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_URL),
  AUTH_TOKEN_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_TOKEN_URL),
  AUTH_THEME: env(ENV_CONFIG_ATTRIBUTES.AUTH_THEME),
  ALTIBOX_MY_PAGES_URL: env(ENV_CONFIG_ATTRIBUTES.ALTIBOX_MY_PAGES_URL),
  CUSTOMER_SERVICE_URL: env(ENV_CONFIG_ATTRIBUTES.CUSTOMER_SERVICE_URL),
  TERMS_LINK_URL: env(ENV_CONFIG_ATTRIBUTES.TERMS_LINK_URL),
  GET_STARTED_URL: env(ENV_CONFIG_ATTRIBUTES.GET_STARTED_URL),
  CUSTOMER_SERVICE_XBOX_URL: env(ENV_CONFIG_ATTRIBUTES.CUSTOMER_SERVICE_XBOX_URL),
  MAIN_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.MAIN_PAGE_URL),
  PICK_UP_URL: DeliveryStaticData.PICK_UP_URL,
  GAME_PASS_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.GAME_PASS_PAGE_URL),
  LANGUAGE: env(ENV_CONFIG_ATTRIBUTES.LANGUAGE),
};
